import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import CustomerMaterialEstimateUnitService
    from "../../../API/orders/estimate/customer/CustomerMaterialEstimateUnitService";
import {useNavigate} from "react-router-dom";
import CustomerEstimateService from "../../../API/orders/estimate/customer/CustomerEstimateService";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import CustomerOrderService from "../../../API/orders/orders/customer/CustomerOrderService";
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, FormGroup,
    LinearProgress,
    linearProgressClasses,
    Typography
} from "@mui/material";
import {offerWaitingTime} from "../../../Constants";

import {calcDiffDate} from "../../../utils/common/calcDiffDate";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import CustomerOrganizationService from "../../../API/customer/CustomerOrganizationService";
import {country} from "../../../data/Country";
import CircularProgress from "@mui/material/CircularProgress";


const CustomerEstimateTableItem = ({
                                       orderId,
                                       customerOrderNumber,
                                       handleModalAlert,
                                       year,
                                       isOrgOne,
                                       offersData,
                                       setOffersData,
                                       initDataOffers
                                   }) => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    const [progress, setProgress] = useState(0);
    const [blockedButton, setBlockedButton] = useState(false);
    const [longWait, setLongWait] = useState(false);
    const [createOffersModal, setCreateOffersModal] = useState(false)
    const [confirmModalOpen, setConfirmModalOpen] = useState(false)

    let timerId

    const createOffers = async (names) => {
        setBlockedButton(true)
        if (isOrgOne) {
            CustomerEstimateService.createOffer(orderId, names[0].name)
                .then(function () {
                    getOffersData(orderId)
                    setConfirmModalOpen(false)
                    handleModalAlert("Предложение рассчитано", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                    setOffersData(initDataOffers)
                }).finally(() => setBlockedButton(false))
        } else {
            CustomerEstimateService.createOffers(orderId, names)
                .then(function () {
                    getOffersData(orderId)
                    setCreateOffersModal(false)
                    handleModalAlert("Предложение рассчитано", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                    setOffersData(initDataOffers)
                }).finally(() => setBlockedButton(false))
        }
    };

    const getOffersData = async (orderId) => {
        clearTimeout(timerId)
        setLongWait(false)
        CustomerOrderService.getCountOffers(orderId).then(function (response) {
            const data = response.data;
            setOffersData(data);
            setProgress((data.calculated + data.finishedError) * 100 / data.all)
            if (data.estimateState === "CALCULATED_OFFERS" && (data.all !== (data.calculated + data.finishedError) && data.all !== 0)) {
                const minutesFromStart = calcDiffDate(data.startCalculate)
                minutesFromStart > offerWaitingTime && setLongWait(true)
                timerId = setTimeout(() => getOffersData(orderId), 4000)
            }
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }

    const cancelOffers = async (orderId) => {
        CustomerOrderService.deleteOffers(orderId).then(function () {
            clearTimeout(timerId)
            setOffersData(initDataOffers)
            handleModalAlert("Предложение отменено", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    };

    const redirectOffers = (orderId, customerOrderNumber, year) => {
        navigate('/customer/orders/' + orderId + '/' + encodeURIComponent(customerOrderNumber) + '/' + year + '/estimates');
    };
    useEffect(() => {
        getOffersData(orderId)

        CustomerMaterialEstimateUnitService.getAllByOrderId(orderId).then(function (response) {
            const data = response.data;
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [])

    useEffect(() => {
        return () => {
            clearTimeout(timerId)
        };
    }, [timerId]);

    const columns = useMemo(
        () => [
            {
                id: 'articleNumber',
                header: 'Артикул',
                accessorKey: 'materialArticleNumber',
                minSize: 15,
                maxSize: 25,
                Cell: ({cell, row}) => {
                    return (
                        <span
                            style={{
                                color: row.original.placeholder ? 'red' : 'black'
                            }}>
                               {cell.getValue()}
                            </span>
                    );
                }
            },
            {
                id: 'materialName',
                header: 'Наименование',
                accessorKey: 'materialName',
                minSize: 50,
                maxSize: 50,
                enableEditing: false,
                Cell: ({cell, row}) => {
                    return (
                        <span
                            style={{
                                color: row.original.placeholder ? 'red' : 'black'
                            }}>
                               {cell.getValue()}
                            </span>
                    );
                }
            },
            {
                id: 'quantity',
                header: 'Кол.',
                accessorKey: 'quantity',
                minSize: 5,
                maxSize: 5,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === 0 ? 0 : value?.toFixed(3)
                }
            },
            {
                id: 'unit.name',
                header: 'Ед. изм.',
                accessorKey: 'unitName',
                minSize: 5,
                maxSize: 5,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                size: 2,
            },
        ],
        [data, setData],
    );

    return (
        <div>
            <Box
                sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}>
                {offersData.estimateState !== "WAIT_OFFERS"
                    ? <Box sx={{display: 'flex', alignItems: 'center', width: "750px", gap: "20px"}}>
                        <Box sx={{width: '100%', mr: 1}}>
                            <LinearProgress variant="determinate" value={progress} sx={{
                                borderRadius: 5,
                                [`& .${linearProgressClasses.bar}`]: {
                                    borderRadius: 5
                                }
                            }}/>
                        </Box>
                        <Box sx={{minWidth: 35}}>
                            <Typography variant="body2" sx={{color: 'text.secondary', width: "270px"}}>
                                {offersData.all === (offersData.calculated + offersData.finishedError) ? `Рассчёт окончен. Рассчитано ${offersData.calculated} из ${offersData.all}` : `Рассчитано ${offersData.calculated} из ${offersData.all}`}
                            </Typography>
                        </Box>
                    </Box>
                    : <Box/>
                }
                <Box sx={{display: 'flex', gap: "20px"}}>
                    <ButtonCreate
                        icon={false}
                        text={"Рассчитать предложения"}
                        disabled={offersData.estimateState !== "WAIT_OFFERS" || blockedButton}
                        width={210}
                        onClick={() => isOrgOne ? setConfirmModalOpen(true) : setCreateOffersModal(true)}
                    />
                    <ButtonCreate
                        icon={false}
                        text={"Отменить предложение"}
                        disabled={!longWait && (offersData.estimateState !== "CALCULATED_OFFERS" || (offersData.all !== (offersData.calculated + offersData.finishedError)))}
                        width={200}
                        onClick={() => cancelOffers(orderId)}
                    />
                    <ButtonCreate
                        icon={false}
                        text={"Смотреть предложения"}
                        disabled={offersData.estimateState === "WAIT_OFFERS" || blockedButton}
                        width={200}
                        onClick={() => redirectOffers(orderId, customerOrderNumber, year)}
                    />
                </Box>
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        muiTableHeadCellProps: {
                            align: 'center',
                        },
                        size: 15,
                        minSize: 15,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 100},
                }}
                enableEditing={false}
                onRowSelectionChange={setRowSelection}
                state={{rowSelection, showGlobalFilter: true}}
                enableRowSelection={false}
                getRowId={(originalRow) => originalRow.id}
                selectionPadding={1}
                selectionCss={{
                    backgroundColor: 'lightblue',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'blue',
                    borderRadius: '4px',
                }}
                localization={MRT_Localization_RU}
                enableToolbarInternalActions={false}
            />
            <ModalCreateOffers
                open={createOffersModal}
                handleClose={() => setCreateOffersModal(false)}
                handleSubmit={createOffers}
                handleModalAlertrror={handleModalAlert}
                blockedButton={blockedButton}
            />
            <ModalCreateOffer
                open={confirmModalOpen}
                handleClose={() => setConfirmModalOpen(false)}
                handleSubmit={createOffers}
                handleModalAlert={handleModalAlert}
                blockedButton={blockedButton}
            />
        </div>
    );
};
const ModalCreateOffer = ({open, handleClose, handleSubmit, handleModalAlert, blockedButton}) => {
    const [allOrganization, setAllOrganization] = useState([])
    useEffect(() => {
        open && CustomerOrganizationService.getAll().then(function (response) {
            const data = response.data.map(el => ({...el, checked: false}))
            setAllOrganization(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [open]);
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Рассчитать предложение?</DialogTitle>
            <DialogContent>
                <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                    {blockedButton && <CircularProgress disableShrink/>}
                    <ButtonExit text={"Отменить"} onClick={handleClose}/>
                    <ButtonAdd disabled={blockedButton} text={"Рассчитать"}
                               onClick={() => handleSubmit(allOrganization)}/>
                </div>
            </DialogContent>
        </Dialog>
    );
};
const ModalCreateOffers = ({open, handleClose, handleSubmit, handleModalAlert, blockedButton}) => {
    const actions = [
        {type: "all", name: "Все организации"},
        {type: "favoriteOrg", name: "Избранные организации"}]
    const [selectedType, setSelectedType] = useState(actions[0]?.type)
    const [allOrganization, setAllOrganization] = useState([])

    useEffect(() => {
        open && CustomerOrganizationService.getAll().then(function (response) {
            const data = response.data.map(el => ({...el, checked: false}))
            setAllOrganization(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [open]);

    const onclick = () => {
        const names = allOrganization.filter(el => el.checked).map(el => el.name)
        handleSubmit(names)
    }
    return (
        <div>
            <Dialog open={open} onClose={handleClose} PaperProps={{
                style: {
                    maxHeight: `800px`,
                }
            }}>
                <DialogTitle> Выбрать организации</DialogTitle>
                <DialogContent>
                    <RadioGroup
                        defaultValue="female"
                        aria-labelledby="demo-customized-radios"
                        name="customized-radios"
                        value={selectedType}
                        onChange={(event) => setSelectedType(event.target.value)}
                    >
                        {actions.map((option) => (
                                <FormControlLabel
                                    key={option.type}
                                    value={option.type}
                                    control={<Radio/>}
                                    label={option.name}
                                    sx={{
                                        margin: 0,
                                        height: "36px",
                                        "&:not(:last-of-type)": {
                                            marginBottom: "4px",
                                        },
                                        borderBottom: (theme) => `${theme.palette.primary.stroke} solid 1px`,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light
                                        }
                                    }
                                    }
                                />
                            )
                        )}
                    </RadioGroup>
                    {selectedType === "favoriteOrg" &&
                        <FormGroup sx={{padding: "10px 0 0 20px"}}>{allOrganization.map(org => {
                            return <FormControlLabel
                                key={org.name}
                                control={<Checkbox/>}
                                checked={org.checked}
                                label={`${org.name} ( ${country[org.country]} )`}
                                onChange={() => setAllOrganization(prev => (prev.map(el => org.name === el.name ? {
                                    ...el,
                                    checked: !el.checked
                                } : el)))}/>
                        })}
                        </FormGroup>
                    }
                </DialogContent>
                <DialogActions>
                    <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                        {blockedButton && <CircularProgress disableShrink/>}
                        <ButtonExit text={"Отменить"} onClick={handleClose}/>
                        <ButtonAdd disabled={blockedButton} text={"Выбрать"} onClick={onclick}/>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default CustomerEstimateTableItem;

